module.exports = __webpack_public_path__ + "img/w3_circle_trash_delete_dark.0067c11d.png";